import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { capturePageView } from './posthog';

export function usePageTracking() {
  const location = useLocation();

  useEffect(() => {
    const url = `${window.location.origin}${location.pathname}${location.search}`;
    capturePageView(url);
  }, [location]);
}
